<template>
    <div class="row pr--article--details">
        <div :class="`col-12 pr-shadow-sm ${item.title !== null ? 'p-3' : 'p-0'} rounded card mb-3 rounded-sm-bottom pr-bg-white pr--card--article`">
            <EditorPreviewDefault
                :item="item"
                :blocks="item.editor.blocks"
                :check-focused="false"
                :prepend="[]"
                :prepends="item.editor.prepends"
            />
        </div>
    </div>
</template>

<script>

import { defineComponent } from 'vue';
import EditorPreviewDefault from '@/components/Editor/Preview/EditorPreviewDefault.vue';
import useI18nRoute from '@/hooks/i18nRoute';

export default defineComponent({
    name: 'FrontendPageDetails',
    components: {
        EditorPreviewDefault
    },
    props: {
        item: {
            type: [Object],
            default: () => {
                return {};
            },
        }
    },
    setup() {
        const i18nRoute = useI18nRoute();
        return {
            i18nRoute,
        };
    }
});
</script>
